import { useTranslation } from 'next-i18next';
import { FormEvent, useContext, useState, VFC } from 'react';

import styles from '@/containers/MarketplacePage/FilterSideBar/FilterSideBar.module.scss';
import MarketplaceItemsContext from '@/contexts/MarketplaceItemsContext';
import ChevronRight2 from '@/icons/chevron-right2.svg';

type Props = {
  priceMin: string;
  setPriceMin: (priceMin: string) => void;
  priceMax: string;
  setPriceMax: (priceMax: string) => void;
}

const PriceRange: VFC<Props> = ({priceMin, setPriceMin, priceMax, setPriceMax}:Props) => {
  const { t } = useTranslation();

  const { searchConditionNFTs, setSearchConditionNFTs } = useContext(
    MarketplaceItemsContext
  );

  const [error, setError] = useState('');
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleFormSubmit = (e: FormEvent): void => {
    e.preventDefault();
    if (priceMax === '' || (priceMax !== '' && priceMin <= priceMax)) {
      setError('');
      const newSearchConditionNFTs = {
        ...searchConditionNFTs,
        priceMin: priceMin.length ? priceMin : null,
        priceMax: priceMax.length ? priceMax : null,
      };
      setSearchConditionNFTs(newSearchConditionNFTs);
    } else {
      setError(t('filterSidebar.priceRange.minMaxError'));
    }
  };

  return (
    <div className={styles.sidebarSubsection}>
      <div className={styles.title}>
        {t('filterSidebar.priceRange.heading')}
      </div>
      <ChevronRight2
        className={
          isCollapsed ? styles.collapseButtonClicked : styles.collapseButton
        }
        onClick={() => {
          setIsCollapsed(!isCollapsed);
        }}
      />
      {!isCollapsed && (
        <form onSubmit={handleFormSubmit} className={styles.priceRangeForm}>
          <div>
            <input
              type="number"
              step={0.01}
              min={0}
              max={10000}
              value={priceMin}
              onChange={(e) => setPriceMin(e.target.value)}
              placeholder={t('filterSidebar.priceRange.minInputPlaceholder')}
            />
            <input
              type="number"
              step={0.01}
              min={0}
              max={10000}
              value={priceMax}
              onChange={(e) => setPriceMax(e.target.value)}
              placeholder={t('filterSidebar.priceRange.maxInputPlaceholder')}
            />
          </div>
          <button type="submit">
            {t('filterSidebar.priceRange.setButtonText')}
          </button>
          {error !== '' && (
            <div className={styles.container}>
              <div className={styles.errorMessage}>{error}</div>
            </div>
          )}
        </form>
      )}
    </div>
  );
};

export default PriceRange;
